import { CLEAR_SOS_FORM } from "../actions/types";

const initialState = { clearSosForm: [] };

const clearSosFormReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case CLEAR_SOS_FORM:
      return {
        ...state,
        clearSosForm: payload,
      };

    default:
      return state;
  }
};

export { clearSosFormReducer };
